<upload-files-modal>

    <dialog id="upload-files-modal" class="modal" ref="dialog" aria-labelledby="upload-files-modal-title">
        <div class="modal-box max-w-2xl">
            <form method="dialog" if="{state.complete}">
                <button class="absolute end-2 top-2 cursor-pointer text-xl"
                        aria-label="{locale?.t('close')}">
                    <i class="icon-clear"></i>
                </button>
            </form>

            <template if="{!state.complete}">
                <h3 id="upload-files-modal-title" class="font-bold text-lg mb-2 text-primary">{locale?.t('upload_inprogress')}</h3>

                <div class="text-center p-4">
                    <span class="loading loading-spinner loading-lg mb-4" style="width: 50px; height: 50px"></span>
                    <p class="font-semibold">{state.uploadingMessage}</p>
                </div>
            </template>

            <template if="{state.complete}">
                <h3 id="upload-files-modal-title"
                    class="font-bold text-lg mb-2 {anyUploaded() ? 'text-primary' : 'text-red-900'}">{headingText()}</h3>

                <!-- Common uploaded files section -->
                <template if="{state.uploadedFileNames && state.uploadedFileNames.length}">
                    <p class="mb-2 font-semibold" is="raw" html="{state.completeMessage}"></p>

                    <ul class="mb-2 ps-4 list-disc {state.uploadedFileNames.length > 1 ? 'grid grid-cols-1 md:grid-cols-2 gap-x-8' : ''}">
                        <li each="{(name, index) in state.uploadedFileNames}"
                            if="{state.showAllUploads || index < 6}"
                            class="text-sm font-medium break-words pb-1">
                            {name}
                        </li>
                    </ul>

                    <button if="{state.uploadedFileNames.length > 6}"
                            type="button"
                            class="btn btn-xs bg-white p-2 w-24 mb-4"
                            onclick="{toggleShowAllUploads}">
                        <template if="{!state.showAllUploads}">
                            <i class="icon-plus text-xs"></i> {locale?.t('viewmore')}
                        </template>
                        <template if="{state.showAllUploads}">
                            <i class="icon-minus text-xs"></i> {locale?.t('viewless')}
                        </template>
                    </button>
                </template>

                <!-- Common failed files section -->
                <div class="mb-4" if="{state.failedFileNames && state.failedFileNames.length > 0}">
                    <p class="mb-2 font-semibold text-red-900">{locale?.t('upload_filesfailedtoupload')}</p>
                    <ul class="ps-4 list-disc {state.failedFileNames.length > 1 ? 'grid grid-cols-1 md:grid-cols-2 gap-x-8' : ''}">
                        <li each="{name in state.failedFileNames}" class="text-sm font-medium text-red-900 break-words pb-1">
                            {name}
                        </li>
                    </ul>
                </div>


                <p class="mb-2 font-semibold" if="{!state.onUploadPage}">
                    {locale?.t('upload_viewqueue')}
                </p>

                <div class="modal-action justify-end">
                    <form method="dialog" class="flex gap-2">
                        <button class="btn text-primary rounded-lg">{locale?.t('close')}</button>
                        <button
                                class="btn btn-primary rounded-lg"
                                if="{!state.onUploadPage}"
                                onclick="{() => tools?.navigateTo('upload')}">
                            {locale?.t('upload_viewprocessing')}
                        </button>
                    </form>
                </div>
            </template>

        </div>

        <form method="dialog" class="modal-backdrop" if="{state.complete}">
            <button>close</button>
        </form>
    </dialog>

    <script>
        import { getCurrentRoute } from "../router/routes"
        import raw from "./raw.tag"

        export default {
            components: {
                raw
            },

            state: {
                onUploadPage: false,
                uploadedFileNames: [],
                uploadedResourceIds: [],
                failedFileNames: [],
                complete: false,
                completeMessage: null,
                uploadingMessage: null,
                showAllUploads: false
            },

            show() {
                const currentRoute = getCurrentRoute();
                if (currentRoute === "#upload") {
                    this.state.onUploadPage = true;
                }

                this.state.complete = false;
                this.state.uploadedFileNames = [];
                this.state.uploadedResourceIds = [];
                this.state.failedFileNames = [];
                this.state.showAllUploads = false;

                this.$('dialog').showModal();
            },

            updateLoadingMessage(complete, total) {
                this.state.uploadingMessage = this.locale?.t('upload_filesuploaded', { complete, total }) || (complete + ' of ' + total + ' Files Uploaded');
                this.update();
            },

            /** Whether anything actually made it to the Processing Queue. */
            anyUploaded() {
                return Boolean(this.state.uploadedFileNames && this.state.uploadedFileNames.length);
            },

            /**
             * The title, chosen from the outcome rather than assumed.
             *
             * It read 'Upload Complete' unconditionally, so a run where every file
             * failed — or where nothing was even attempted — announced success in the
             * most prominent element on screen while the failure detail sat below it.
             * Both strings already exist in every locale, so this needs no new copy.
             */
            headingText() {
                return this.anyUploaded()
                    ? this.locale?.t('upload_complete')
                    : this.locale?.t('upload_nofiles');
            },

            showCompleteMessage(message, uploadedFileNames = [], uploadedResourceIds = [], failedFileNames = []) {
                this.state.uploadedFileNames = uploadedFileNames;
                this.state.uploadedResourceIds = uploadedResourceIds;
                this.state.failedFileNames = failedFileNames;
                this.state.completeMessage = message || this.locale?.t('upload_completemessage') || 'The files below have been uploaded to your Processing Queue:';
                this.state.complete = true;

                this.update();
            },

            toggleShowAllUploads() {
                this.state.showAllUploads = !this.state.showAllUploads;
                this.update();
            },

            close() {
                this.$('dialog').close();
            },

            async onMounted() {
                // Make globally accessible
                window.uploadFilesModal = this;
            }
        }
    </script>
</upload-files-modal>